import { AuthProvider, getAuth, signInWithRedirect } from 'firebase/auth'

import { emitSystemNotification } from 'state/system_notification'

/**
 * Start an social media oauth2 process using the given {@link AuthProvider}
 * @param provider to use for the oauth2 process
 */
export const signInWithOauth2 = async (provider: AuthProvider) => {
	const auth = getAuth()

	try {
		await signInWithRedirect(auth, provider)
	} catch (error: unknown) {
		console.error(error)
		if (error instanceof Error) {
			emitSystemNotification({
				display: 'dialog',
				variant: 'error',
				title: 'Error',
				message:
					error.message ||
					error.toString() ||
					'Unknown error trying to sign in with GitHub'
			})
		}
	}
}
